module.exports = __webpack_public_path__ + "static/paycheck-logo-a33b05bd3c993cbde1decd80691b486d.png";